import React, { createContext, useContext } from "react";

interface ReadonlyContextValue {
  readonly: boolean;
}

const ReadonlyContext = createContext<ReadonlyContextValue | null>(null);

export interface ReadonlyProviderProps {
  children: React.ReactNode;
  readonly?: boolean;
}

export const ReadonlyProvider: React.FC<ReadonlyProviderProps> = ({
  children,
  readonly = false,
}) => {
  const value: ReadonlyContextValue = {
    readonly,
  };

  return <ReadonlyContext.Provider value={value}>{children}</ReadonlyContext.Provider>;
};

export const useReadonly = (): ReadonlyContextValue => {
  const context = useContext(ReadonlyContext);

  if (context === null) {
    throw new Error("useReadonly must be used within a ReadonlyProvider");
  }

  return context;
};

export const useIsReadonly = (): boolean => {
  const { readonly } = useReadonly();
  return readonly;
};
